import { useCallback, useMemo, useState } from 'react';

type UseModalReturnValue<T> = {
  isOpen: boolean;
  open: (val?: T) => void;
  close: () => void;
  value: T | undefined;
};

export const useModalObject = <T = any>(closeCallback?: () => void) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState<T>();

  const close = useCallback(() => {
    if (closeCallback) closeCallback();
    setIsOpen(false);
  }, [closeCallback]);

  const open = useCallback((val?: T) => {
    if (val) setValue(val);
    setIsOpen(true);
  }, []);

  return useMemo<UseModalReturnValue<T>>(() => ({ isOpen, open, close, value }), [isOpen, open, close, value]);
};

type LegacyUseModalReturnValue<T> = [boolean, (val?: T) => void, () => void, T | undefined];

function useLegacyModal<T = any>(closeCallback?: () => void): LegacyUseModalReturnValue<T> {
  const modal = useModalObject(closeCallback);
  return [modal.isOpen, modal.open, modal.close, modal.value];
}

export default useLegacyModal;
